import { TemplateEmptyState } from './TemplateShared';

export interface TemplateSummaryHeaderProps {
  title: string;
  subtitle?: string;
  note?: string;
}

export const TemplateSummaryHeader = ({
  title,
  subtitle,
  note,
}: TemplateSummaryHeaderProps) => (
  <div className="flex items-baseline justify-between">
    <div className="flex flex-col gap-1">
      <p className="text-[14px] leading-tight font-bold text-zinc-700">
        {title}
      </p>
      {subtitle ? (
        <p className="text-[10px] leading-tight text-zinc-500 italic">
          {subtitle}
        </p>
      ) : null}
    </div>
    {note ? (
      <p className="text-[10px] leading-tight text-zinc-500 italic">{note}</p>
    ) : null}
  </div>
);

export interface TemplateAppendixLayoutProps {
  hasItems: boolean;
  emptyMessage: string;
  summaryHeader: React.ReactNode;
  summaryTable: React.ReactNode;
  appendixTitle?: string;
  appendix?: React.ReactNode;
  summarySectionClassName?: string;
  appendixSectionClassName?: string;
}

export const TemplateAppendixLayout = ({
  hasItems,
  emptyMessage,
  summaryHeader,
  summaryTable,
  appendixTitle = 'Appendix',
  appendix,
  summarySectionClassName = 'flex flex-col gap-3 px-8 py-5',
  appendixSectionClassName = 'flex flex-1 flex-col gap-4 px-8 py-5',
}: TemplateAppendixLayoutProps) => (
  <>
    <section className={summarySectionClassName}>
      {summaryHeader}
      {hasItems ? summaryTable : <TemplateEmptyState message={emptyMessage} />}
    </section>
    {hasItems && appendix ? (
      <section className={appendixSectionClassName}>
        {appendixTitle ? (
          <p className="text-[14px] leading-tight font-bold text-zinc-700">
            {appendixTitle}
          </p>
        ) : null}
        {appendix}
      </section>
    ) : null}
  </>
);
